var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.2,
    height: 37.5,
    viewBox: "0 0 46.2 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3,26.6v1.2c0,12.5-9.5,26.9-26.9,26.9a27.615,27.615,0,0,1-14.5-4.2,16.95,16.95,0,0,0,2.3.1,19.016,19.016,0,0,0,11.7-4A9.462,9.462,0,0,1,18.1,40a11.019,11.019,0,0,0,1.8.2,10.075,10.075,0,0,0,2.5-.3,9.542,9.542,0,0,1-7.6-9.3v-.1a10.207,10.207,0,0,0,4.3,1.2,9.571,9.571,0,0,1-4.2-7.9A9.849,9.849,0,0,1,16.2,19a26.971,26.971,0,0,0,19.5,9.9,7.845,7.845,0,0,1-.2-2.2A9.5,9.5,0,0,1,45,17.2a9.212,9.212,0,0,1,6.9,3,17.419,17.419,0,0,0,6-2.3,9.067,9.067,0,0,1-4.2,5.2,16.694,16.694,0,0,0,5.4-1.5A17.622,17.622,0,0,1,54.3,26.6Z",
    transform: "translate(-12.9 -17.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.b3a2fd32.svg";
export { ForwardRef as ReactComponent };